import { Link } from 'react-router-dom';
import { relatedTitles } from '@/mocks/related';

export default function RecommendSection() {
  const featured = relatedTitles.slice(0, 3);

  return (
    <section className="bg-background-100 border-y border-background-300/40">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="text-xs tracking-[0.3em] text-accent-400 font-heading uppercase">
            You May Also Like
          </span>
          <h2 className="font-heading font-semibold text-foreground-950 text-2xl md:text-3xl mt-2 mb-4">
            推荐专题
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            如果你喜欢《无颜之月》中那份克制、幽暗又温柔的叙事气质，这些同风格影视作品可能同样合你心意。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((item) => (
            <Link
              key={item.id}
              to={`/related/${item.id}`}
              className="group relative rounded-lg overflow-hidden border border-background-300/40 hover:border-accent-500/60 transition-colors cursor-pointer"
            >
              <div className="w-full h-72 md:h-80 overflow-hidden bg-background-200">
                <img
                  src={item.poster}
                  alt={`${item.title} 海报`}
                  title={`${item.title} ${item.genre} 推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/50 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-secondary-100/90 text-secondary-900 text-xs mb-2">
                  {item.genre}
                </span>
                <h3 className="font-heading font-semibold text-foreground-950 text-lg mb-1 group-hover:text-accent-300 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  {item.synopsis}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/related"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-compass-3-line" />
            探索更多相关推荐
          </Link>
        </div>
      </div>
    </section>
  );
}